import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCSRReceiptStore from "../../stores/csr-store/csr-receipt-event-count";
import { et3ReadableDecimalNumber } from "../../helpers/et3-data-helper";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import { getPermissionIDRequired } from "../../helpers/et3-has-permission";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import React from "react";
import getDashBoardStore from "../../stores/dashboard-store";
import {
  SIDE_BAR_SALARY_BLOCK_HEIGHT,
  SIDE_BAR_SALARY_FONT_SIZE,
  SIDE_BAR_SALARY_LABEL_FONT_SIZE,
  SIDE_BAR_SALARY_LABEL_OPACITY,
  SIDE_BAR_SALARY_LETTER_SPACING
} from "./side-bar-constants";

const AdminSalary = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isKhattabaAdmin = getCorePersonalStore().isManualKhattabaAdmin.get();
  const adminSalary = isKhattabaAdmin
    ? getDashBoardStore().khattabatAdminRemuneration.get()
    : getCSRReceiptStore().finalCSRSalary.get();
  const roundedSalary = `${et3ReadableDecimalNumber(adminSalary, 2)}`;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const ifAdminHasCSRPermission =
    userPermissions.indexOf(getPermissionIDRequired("CSR")) > -1 ||
    isKhattabaAdmin;

  return !ifAdminHasCSRPermission ? null : (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={SIDE_BAR_SALARY_BLOCK_HEIGHT}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={SIDE_BAR_SALARY_LABEL_FONT_SIZE}
          text={i18n.get("SALARY")}
          isSpan={false}
          color={colors.all.white}
          style={{
            margin: 0,
            opacity: SIDE_BAR_SALARY_LABEL_OPACITY,
            letterSpacing: SIDE_BAR_SALARY_LETTER_SPACING * unitX
          }}
        />
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={SIDE_BAR_SALARY_FONT_SIZE}
          text={`${roundedSalary} $`}
          isSpan={false}
          color={colors.all.white}
          style={{ margin: 0 }}
        />
      </ET3Div>
      <Et3Margin top={0} left={0} right={0} bottom={30} />
    </React.Fragment>
  );
});
export default AdminSalary;
